import { queryOptions } from '@tanstack/react-query'

import Client from '@/api/client'
import { getConfig } from '@/app/config'

// Value of RuleID.MoT02_EV04_ShipmentCreated (@forto-dev/insights-engine-models), inlined so that
// package stays out of this lazily-loaded chunk.
const SHIPMENT_CREATED_RULE_ID = 'BPT-MOT-02-EV04_shipment_created'

const client = new Client(getConfig().API_ENDPOINT ?? '')

export type CurrentCustomerPreference = {
  user: { id: string }
  preferences: Array<{ reference: string; instantEmail: boolean }>
}

// All customer users' ShipmentCreated preference (backend projects preferences[] to this rule).
export const getCurrentCustomerAcknowledgementPreferences = async (): Promise<CurrentCustomerPreference[]> => {
  const result = await client.get<CurrentCustomerPreference[] | undefined>(
    `/api/notification-center/user-notification-preferences/currentCustomer?ruleID=${SHIPMENT_CREATED_RULE_ID}`
  )
  return result ?? []
}

export const currentCustomerPreferencesQueryOptions = () =>
  queryOptions({
    queryKey: ['acknowledgementReceiverPreferences'],
    queryFn: getCurrentCustomerAcknowledgementPreferences,
  })
